var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2555 -4.70076e-05L9.03566 13.6428L3.13334 7.92091L0.254861 11.3999L9.1169 20L23.7452 2.86967L20.2555 -4.70076e-05Z",
    fill: "#00CA99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2555 -4.70076e-05L9.03566 13.6428L3.13334 7.92091L0.254861 11.3999L9.1169 20L23.7452 2.86967L20.2555 -4.70076e-05Z",
    fill: "#00CA99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/Check mark.be4dea7d9d637fd59680d3106e33ab05.svg";
export { ForwardRef as ReactComponent };